import React, { useEffect, useMemo, useState } from 'react'
import { unstable_batchedUpdates } from 'react-dom'

import { useRouteMatch } from 'react-router-dom'

import AuthTrainingContext from 'contexts/AuthTrainingContext'
import * as service from 'service'

const AuthTrainingProvider = ({ children }) => {
  const routeMatch = useRouteMatch('/training/:portalToken')
  const urlPortalToken = routeMatch?.params?.portalToken

  const [company, setCompany] = useState(null)
  const [loginMode, setLoginMode] = useState(null)
  const [accessType, setAccessType] = useState(null)
  const [theme, setTheme] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [linkInvalid, setLinkInvalid] = useState(false)
  const [portalToken, setPortalToken] = useState(
    urlPortalToken || service.trainingPortal.auth.getPortalToken() || null,
  )

  const loadLink = async (token) => {
    const response = await service.trainingPortal.auth.resolveLink(token)
    const data = response?.data
    // O React não agrupa automaticamente múltiplos setState, cada um dispararia
    // um re-render separado. unstable_batchedUpdates força o React a juntar
    // todas as chamadas setState dentro do callback em um único re-render,
    // evitando estados intermediários inconsistentes.
    // O que dispara o batching não é quantas requests alimentam o estado,
    // mas onde o setState é chamado. todos do mesmo objeto data de uma única
    // resposta — mas são 5 chamadas de setState separadas,
    // dentro de uma função async após um await.
    unstable_batchedUpdates(() => {
      setCompany(data?.company || null)
      setLoginMode(data?.loginMode || null)
      setAccessType(data?.accessType || null)
      setTheme(data?.theme || null)
      setPortalToken(token)
    })
    service.trainingPortal.auth.setPortalToken(token)
  }

  useEffect(() => {
    const bootstrap = async () => {
      const storedPortalToken = service.trainingPortal.auth.getPortalToken()
      const tokenToLoad = urlPortalToken || storedPortalToken

      if (urlPortalToken && urlPortalToken !== storedPortalToken) {
        service.trainingPortal.auth.removeToken()
      }

      if (tokenToLoad) {
        try {
          await loadLink(tokenToLoad)
        } catch {
          unstable_batchedUpdates(() => {
            setLinkInvalid(true)
            setPortalToken(null)
            setCompany(null)
          })
          service.trainingPortal.auth.removePortalToken()
        }
      }

      setLoaded(true)
    }

    bootstrap()
    // eslint-disable-next-line
  }, [urlPortalToken])

  const contextValue = useMemo(
    () => ({
      accessType,
      company,
      linkInvalid,
      loaded,
      loginMode,
      portalToken,
      theme,
    }),
    [accessType, company, linkInvalid, loaded, loginMode, portalToken, theme],
  )

  return (
    <AuthTrainingContext.Provider value={contextValue}>
      {children}
    </AuthTrainingContext.Provider>
  )
}

export default AuthTrainingProvider
